import { getSnippets, loadCollectionItems } from '../pluginComponentApi';
export const getSnippetTraits = async (projectId, version, labelColName) => {
  const snippets = await getSnippets(projectId, version, labelColName);
  let options = [];
  options.push({ value: '', name: '- Select Snippet -' });
  snippets.data.forEach((item, key) => {
    if (item.snippetType === 'SNIPPET') {
      options.push({ value: item.uuid, name: item.name });
    }
  });
  return {
    type: 'select',
    label: labelColName,
    name: 'snippetUuid',
    changeProp: 1,
    options,
  };
};
export const getSnippetRoleTraits = async (projectId, version, labelColName) => {
  const snippets = await getSnippets(projectId, version, labelColName);
  let options = [{ value: '', name: '- Select Snippet -' }];
  snippets.data.forEach((item, key) => {
    if (item.snippetType === 'SNIPPET') {
      options.push({ value: item.uuid, name: item.name });
    }
  });

  const collectionItems = await loadCollectionItems(projectId, version, 'role');
  let snippetRoleTraitsMap = [];
  collectionItems.forEach((item, key) => {
    snippetRoleTraitsMap.push({ userRole: item, snippetOptions: options });
  });

  return snippetRoleTraitsMap;
};
